import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

interface UserDeviceDetails {
    UserDeviceDetails: {
        load: boolean;
        data: [];
    };
}

export const NotificationSlice = createSlice({
    name: "UserDeviceDetails",
    initialState: {
        UserDeviceDetails: {
            load: false,
            data: [],
        },
    } as UserDeviceDetails,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            .addCase(fetchUserDeviceDetails.pending, (state: UserDeviceDetails) => {
                state.UserDeviceDetails.load = true;
            })
            .addCase(fetchUserDeviceDetails.fulfilled, (state: UserDeviceDetails, action: any) => {
                state.UserDeviceDetails.data = action.payload;
                state.UserDeviceDetails.load = false;
            })
            .addCase(fetchUserDeviceDetails.rejected, (state: UserDeviceDetails) => {
                state.UserDeviceDetails.load = false;
            })
            .addCase(EnableMdmSettingsStatus.pending, (state: UserDeviceDetails) => {
                state.UserDeviceDetails.load = true;
            })
            .addCase(EnableMdmSettingsStatus.fulfilled, (state: UserDeviceDetails, action: any) => {
                state.UserDeviceDetails.data = action.payload;
                state.UserDeviceDetails.load = false;
            })
            .addCase(EnableMdmSettingsStatus.rejected, (state: UserDeviceDetails) => {
                state.UserDeviceDetails.load = false;
            });;
    },
});

export default NotificationSlice.reducer;

export const fetchUserDeviceDetails = createAsyncThunk(
    "UserDeviceDetails/fetchUserDeviceDetails",
    async (param: {apiParam: { user_id: any }}, thunkAPI) => {
        try {
            const { data } = await DataServer.post("api/GetUserDeviceDetails", {
                user_id: param.apiParam.user_id
            });
            return data.data;
        } catch (error) {
        }
    }
);

export const ForgetUserDeviceDetails = createAsyncThunk(
    "UserDeviceDetails/ForgetUserDeviceDetails",
    async (param: {apiParam: { user_id: any }, navigation: any}, thunkAPI) => {
        try {
            const { data } = await DataServer.post("api/forgetMDMSettings", {
                user_id: param.apiParam.user_id
            });

            toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

            const handleonConfirm = () => {
                param.navigation("/user-summary");
            };
            return data.data;
        } catch (error) {
        }
    }
);

export const EnableMdmSettings = createAsyncThunk(
    "UserDeviceDetails/ForgetUserDeviceDetails",
    async (param: {apiParam: { company_id: any, mdm: any }, navigation: any}, thunkAPI) => {
        try {
            const { data } = await DataServer.post("api/MDMSettings", {
                company_id: param.apiParam.company_id,
                mdm: param.apiParam.mdm
            });

            toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

            const handleonConfirm = () => {
                param.navigation("/company-summary");
            };

            return data.data;
        } catch (error) {
        }
    }
);

export const EnableMdmSettingsStatus = createAsyncThunk(
    "CompanyDeviceDetails/EnableMdmSettingsStatus",
    async (param: {apiParam: { company_id: any, mdm: any }, navigation: any}, thunkAPI) => {
        try {
            const { data } = await DataServer.post("api/getMDMSettingStatus", {
                company_id: param.apiParam.company_id,
            });
            return data;
        } catch (error) {
        }
    }
);
